import { render, staticRenderFns } from "./format-form.vue?vue&type=template&id=5eb17740&"
import script from "./format-form.vue?vue&type=script&lang=js&"
export * from "./format-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports